"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _underscore = require("underscore");

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _LastStepButton = _interopRequireDefault(require("lead-flows-ui/components/editor/navigation/buttons/LastStepButton"));

var InvalidLastStepButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(InvalidLastStepButton, _PureComponent);

  function InvalidLastStepButton() {
    (0, _classCallCheck2.default)(this, InvalidLastStepButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InvalidLastStepButton).apply(this, arguments));
  }

  (0, _createClass2.default)(InvalidLastStepButton, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.secondaryNavigation." + suffix;
    }
  }, {
    key: "getValidationMessage",
    value: function getValidationMessage(label) {
      var langKeys = {
        publish: 'fixErrorsMessage',
        schedule: 'fixScheduleErrorsMessage'
      };
      return this.langKey(langKeys[label] ? langKeys[label] : 'fixErrorsMessage');
    }
  }, {
    key: "renderValidationSummary",
    value: function renderValidationSummary() {
      var _this = this;

      var validation = this.props.validation;
      return (0, _underscore.map)(Object.keys(validation || {}), function (step) {
        return _this.renderValidationSummaryStep(validation, step);
      });
    }
  }, {
    key: "renderValidationSummaryStep",
    value: function renderValidationSummaryStep(validation, step) {
      var stepName = _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey("steps." + step)
      });

      var errorCount = Object.keys(validation[step] || {}).length;

      if (errorCount > 1) {
        return _react.default.createElement("li", {
          key: step
        }, _react.default.createElement(_FormattedReactMessage.default, {
          message: this.langKey('errorsOnTab'),
          options: {
            errorCount: errorCount,
            stepName: stepName
          }
        }));
      }

      return _react.default.createElement("li", {
        key: step
      }, _react.default.createElement(_FormattedReactMessage.default, {
        message: this.langKey('errorsOnTab'),
        options: {
          errorCount: 1,
          stepName: stepName
        }
      }));
    }
  }, {
    key: "renderTooltipContent",
    value: function renderTooltipContent() {
      var label = this.props.label;
      var validationMessage = this.getValidationMessage(label);
      var validationSummary = this.renderValidationSummary();
      return _react.default.createElement("div", {
        className: "secondary-navigation__validation-content"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: validationMessage
      }), _react.default.createElement("br", null), _react.default.createElement("ul", null, validationSummary));
    }
  }, {
    key: "render",
    value: function render() {
      var label = this.props.label;
      return _react.default.createElement(_UITooltip.default, {
        placement: "bottom",
        title: this.renderTooltipContent(),
        className: "secondary-navigation__publish-tooltip"
      }, _react.default.createElement("div", null, _react.default.createElement(_LastStepButton.default, {
        label: label,
        disabled: true
      })));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        label: _react.PropTypes.string,
        validation: _react.PropTypes.object
      };
    }
  }]);
  return InvalidLastStepButton;
}(_react.PureComponent);

exports.default = InvalidLastStepButton;
module.exports = exports.default;